{
  "zh-TW": {
    "chart": {
      "labels": {
        "view": {
          "one": "%{label}:<br><b>%{count}</b> 瀏覽",
          "other": "%{label}:<br><b>%{count}</b> 瀏覽"
        },
        "ship": {
          "one": "%{label}:<br><b>%{count}</b> 飛船",
          "other": "%{label}:<br><b>%{count}</b> 飛船"
        },
        "ship-pie": {
          "one": "%{label}:<br><b>%{count}</b> 飛船 (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> 飛船 (%{percentage} %)"
        },
        "component-pie": {
          "one": "%{label}:<br><b>%{count}</b> 組件 (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> 組件 (%{percentage} %)"
        },
        "user": {
          "one": "%{label}:<br><b>%{count}</b> 使用者",
          "other": "%{label}:<br><b>%{count}</b> 使用者"
        },
        "user-pie": {
          "one": "%{label}:<br><b>%{count}</b> User (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Users (%{percentage} %)"
        },
        "visit": {
          "one": "%{label}:<br><b>%{count}</b> 訪問",
          "other": "%{label}:<br><b>%{count}</b> 訪問"
        }
      }
    }
  }
}
